import { Component, Input, OnInit } from '@angular/core'
import { DateFormatService } from 'dmmp-services'

@Component({
  selector: 'dmmp-blog-view',
  templateUrl: './blog-view.component.html'
})
export class BlogViewComponent implements OnInit {

  @Input() blogInfo
  @Input() module

  constructor(private dateFormatService: DateFormatService) { }

  ngOnInit(): void {
    this.blogInfo.promotion_date = this.dateFormatService.convertFromTimestampToDate(this.blogInfo?.promotion_date)
  }

}
